import {Component, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ContactComponent} from './contact/contact.component';
import {HomeComponent} from './home/home.component';
import {TeamComponent} from './team/team.component';
import {ExaminationComponent} from './examination/examination.component';
import {ServicesComponent} from './services/services.component';
import {VasektomieComponent} from './vasektomie/vasektomie.component';
import {ImpressumComponent} from "./impressum/impressum.component";

const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'leistungen', component: ServicesComponent},
  {path: 'untersuchungen', component: ExaminationComponent},
  {path: 'vasektomie', component: VasektomieComponent},
  {path: 'praxis', component: TeamComponent},
  {path: 'kontakt', component: ContactComponent},
  {path: 'impressum', component: ImpressumComponent},
  {path: '**', redirectTo: 'home'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
    {useHash: true, scrollPositionRestoration: 'enabled',
      // anchorScrolling: 'enabled',
      // scrollOffset: [0, 100],
      onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
